"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _jsxFileName = "/Users/john/Desktop/Projects/nq-component/src/ButtonGroup/index.js";
var defaultProps = {
  onClick: function onClick() {}
};
function ButtonGroup(_ref) {
  var _this = this;
  var options = _ref.options,
    onClick = _ref.onClick;
  var _React$useState = _react["default"].useState(0),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    position = _React$useState2[0],
    setPosition = _React$useState2[1];
  function _onClick(index) {
    setPosition(index);
    onClick(options[index], index);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "btn-group",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 9
    }
  }, options.map(function (o, i) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      onClick: _onClick.bind(_this, i),
      className: (0, _classNames["default"])("btn btn-outline-primary", position === i && 'active'),
      type: "button",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 25
      }
    }, o.label);
  }));
}
ButtonGroup.defaultProps = defaultProps;
var _default = exports["default"] = ButtonGroup;